import { css } from "lit";

export const styles = css`
  :host {
    display: block;
    width: 100%;
    height: 100%;
  }

  .panel {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    gap: 16px;
    padding: 32px 24px;
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    background: var(--sds-color-background-default-tertiary);
    color: var(--sds-color-text-default-default);
  }

  .icon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 56px;
    height: 56px;
    border-radius: 50%;
    background: var(--sds-color-background-danger-subtle);
    color: var(--sds-color-text-danger-default);
  }

  h3 {
    margin: 0;
    font: var(--sds-typography-weight-medium) var(--sds-typography-scale-04) var(--sds-typography-family-title);
    line-height: 120%;
    max-width: 480px;
  }

  p {
    margin: 0;
    color: var(--sds-color-text-default-secondary);
    font: var(--sds-typography-weight-regular) var(--sds-typography-scale-02) var(--sds-typography-family-body);
    line-height: 140%;
    max-width: 480px;
  }

  .actions {
    display: flex;
    gap: 8px;
    margin-top: 8px;
  }
`;
